module.exports = __webpack_public_path__ + "img/1725845237800-WhatsApp Image 2024-08-14 at 09.41.22.jpeg.1b7b67e6.webp";